import { DEFAULT_CHAIN_ID, HYPEREVM, SONIC } from 'config/chains'
import { CLOUD_FRONT_URL } from 'config/constants'
import { ZKSYNC } from './chains'
import { IS_VERBOSE } from './development'
import { AddressZero } from 'utils/ethersImport'

export type Token = {
  name: string
  color?: string
  symbol: string
  baseSymbol?: string
  decimals: number
  address: string
  priceDecimals?: number
  wrappedAddress?: string
  storkID?: string
  storkBaseID?: string
  coingeckoUrl?: string
  explorerUrl?: string
  reservesUrl?: string
  imageUrl?: string
  pythId?: string
  baseId?: string
  id?: string
  baseAddress?: string
  quoteAddress?: string
  slug?: string

  isUsdg?: boolean
  isNative?: boolean
  isWrapped?: boolean
  isShortable?: boolean
  isStable?: boolean
  isSynthetic?: boolean
  isTempHidden?: boolean
  isChartDisabled?: boolean
  isV1Available?: boolean
  isPlatformToken?: boolean

  isChartForMultiChartPage?: boolean
  needsLiveDataFetching?: boolean
  tag?: string
  acrossAddress?: string
}

export const NATIVE_TOKEN_ADDRESS = AddressZero

export const TOKENS: { [chainId: number]: Token[] } = {
  [HYPEREVM]: [
    {
      name: 'HYPE',
      symbol: 'HYPE',
      decimals: 18,
      storkID: 'HYPEUSDMARK',
      address: AddressZero,
      pythId:
        '0x4279e31cc369bbcc2faf022b382b080e32a8e689ff20fbc530d2a603eb6cd98b',
      isNative: true,
      wrappedAddress: '0x5555555555555555555555555555555555555555',
      isShortable: true,
      imageUrl: CLOUD_FRONT_URL + '/assets/eth.svg',
      coingeckoUrl: 'https://www.coingecko.com/en/coins/ethereum',
      isChartForMultiChartPage: true,
      needsLiveDataFetching: true,
      tag: 'L1',
      color: '#828384',
    },
    {
      name: 'WHYPE',
      symbol: 'WHYPE',
      decimals: 18,
      storkID: 'HYPEUSDMARK',
      address: '0x5555555555555555555555555555555555555555',
      isWrapped: true,
      pythId:
        '0x4279e31cc369bbcc2faf022b382b080e32a8e689ff20fbc530d2a603eb6cd98b',
      wrappedAddress: '0x5AEa5775959fBC2557Cc8789bC1bf90A239D9a91',
      isShortable: true,
      imageUrl: CLOUD_FRONT_URL + '/assets/eth.svg',
      coingeckoUrl: 'https://www.coingecko.com/en/coins/ethereum',
      needsLiveDataFetching: true,
      tag: 'L1',
      color: '#828384',
    },
    {
      name: 'WSTHYPE',
      symbol: 'WSTHYPE',
      decimals: 18,
      storkID: 'HYPEUSDMARK',
      address: '0x76Fa6da515F9B598b65Bbbdf83e019C36B949B1C',
      pythId:
        '0x4279e31cc369bbcc2faf022b382b080e32a8e689ff20fbc530d2a603eb6cd98b',
      wrappedAddress: '0x5AEa5775959fBC2557Cc8789bC1bf90A239D9a91',
      isShortable: true,
      imageUrl: CLOUD_FRONT_URL + '/assets/eth.svg',
      coingeckoUrl: 'https://www.coingecko.com/en/coins/ethereum',
      needsLiveDataFetching: true,
      tag: 'L1',
      color: '#828384',
    },
    {
      name: 'F1 NORRIS',
      symbol: 'F1_NORRIS',
      decimals: 18,
      storkID: 'PM_F1_DC_25_NORRIS_Y',
      slug: 'will-lando-norris-be-the-2025-drivers-champion',
      address: '0xD9Ac0f758114EfcB2E42846b1D1AE7D8138d609e',
      pythId:
        '0x9d4294bbcd1174d6f2003ec365831e64cc31d9f6f15a2b85399db8d5000960f7',
      isShortable: true,
      imageUrl:
        'https://polymarket-upload.s3.us-east-2.amazonaws.com/will-lando-norris-be-the-2025-drivers-champion-wtd-w02XwSsY.png',
      coingeckoUrl: 'https://www.coingecko.com/en/coins/ethereum',
      isChartForMultiChartPage: true,
      needsLiveDataFetching: true,
      tag: 'L1',
      color: '#828384',
    },
    {
      name: 'WETH',
      symbol: 'WETH',
      decimals: 18,
      storkID: 'ETHUSDMARK',
      address: '0x0203e383644a540ee28ac3eD8F99A29c5b88C9C2',
      pythId:
        '0xff61491a931112ddf1bd8147cd1b641375f79f5825126d665480874634fd0ace',
      wrappedAddress: '0x5AEa5775959fBC2557Cc8789bC1bf90A239D9a91',
      isShortable: true,
      imageUrl: CLOUD_FRONT_URL + '/assets/eth.svg',
      coingeckoUrl: 'https://www.coingecko.com/en/coins/ethereum',
      needsLiveDataFetching: true,
      tag: 'L1',
      color: '#828384',
    },
    {
      name: 'WBTC',
      symbol: 'WBTC',
      decimals: 18,
      storkID: 'BTCUSDMARK',
      address: '0xF651b6734FAd88936dF82D05c2dcD9B2bF914dc1',
      pythId:
        '0xe62df6c8b4a85fe1a67db44dc12de5db330f7ac66b72dc658afedf0f4a415b43',
      wrappedAddress: '0x5AEa5775959fBC2557Cc8789bC1bf90A239D9a91',
      isShortable: true,
      imageUrl: CLOUD_FRONT_URL + '/assets/eth.svg',
      coingeckoUrl: 'https://www.coingecko.com/en/coins/ethereum',
      needsLiveDataFetching: true,
      tag: 'L1',
      color: '#828384',
    },
    {
      name: 'S',
      symbol: 'S',
      decimals: 18,
      storkID: 'SUSDMARK',
      address: '0x66eC68c3882fD6581c66c237FeB0CD07040f2ab5',
      pythId:
        '0xf490b178d0c85683b7a0f2388b40af2e6f7c90cbe0f96b31f315f08d0e5a2d6d',
      isShortable: true,
      imageUrl: CLOUD_FRONT_URL + '/assets/eth.svg',
      coingeckoUrl: 'https://www.coingecko.com/en/coins/ethereum',
      isChartForMultiChartPage: true,
      needsLiveDataFetching: true,
      tag: 'L1',
      color: '#828384',
    },
    {
      name: 'NVDA',
      symbol: 'NVDA',
      decimals: 18,
      storkID: 'NVDA',
      address: '0x2d0180F7702B79A7F43096d378D985da9E0408dd',
      pythId:
        '0xb1073854ed24cbc755dc527418f52b7d271f6cc967bbf8d8129112b18860a593',
      isShortable: true,
      imageUrl: CLOUD_FRONT_URL + '/assets/eth.svg',
      coingeckoUrl: 'https://www.coingecko.com/en/coins/ethereum',
      isChartForMultiChartPage: true,
      needsLiveDataFetching: true,
      tag: 'L1',
      color: '#828384',
    },
    {
      name: 'SLV WSTHYPE',
      symbol: 'SLV WSTHYPE',
      decimals: 6,
      priceDecimals: 4,
      address: '0x024cD51E3F0D2A8214DCcaB7d86EaD8593acB90a',
      imageUrl: CLOUD_FRONT_URL + '/assets/glm.svg',
      coingeckoUrl: 'https://www.coingecko.com/en/coins/dogecoin',
      color: '#4E4E4E',
    },
    {
      name: 'GMX Market tokens',
      symbol: 'RP',
      address: '<market-token-address>',
      decimals: 18,
      imageUrl:
        'https://raw.githubusercontent.com/gmx-io/gmx-assets/main/GMX-Assets/PNG/GM_LOGO.png',
      isPlatformToken: true,
    },
  ],
}

export const POOL_COLORS: Record<string, string> = {
  ETH: '#6062a6',
  'ETH/BTC': '#6062a6',
  BTC: '#F7931A',
  WBTC: '#F7931A',
  USDC: '#2775CA',
  'USDC.e': '#2A5ADA',
  USDT: '#67B18A',
  MIM: '#9695F8',
  FRAX: '#000',
  DAI: '#FAC044',
  UNI: '#E9167C',
  AVAX: '#E84142',
  LINK: '#3256D6',
  XRP: '#1b95ca',
  S: '#001E76',
  SOL: '#DC1FFF',
  HYPE: '#0E4D45',
  WIF: '#D38FA6',
  AAVE: '#9391FE',
  'AAVE/BNB': '#9391FE',
  'AAVE/AVAX': '#9391FE',
  'AAVE/APT': '#9391FE',
  'AAVE/ADA': '#9391FE',
  'AAVE/BTC': '#9391FE',
  ARB: '#10A2EA',
  FARTCOIN: '#303030',
  PEPE: '#4C9641',
  SUI: '#5BA9FF',
  DOGE: '#BBA033',
  ENA: '#1E1E1E',
  TRUMP: '#BCA260',
}

export const CHAIN_NAME: Record<number, string> = {
  [SONIC]: 'Sonic',
  [ZKSYNC]: 'zkSync Era',
}
export const TOKENS_MAP: { [chainId: number]: { [address: string]: Token } } =
  {}
export const V1_TOKENS: { [chainId: number]: Token[] } = {}
export const V2_TOKENS: { [chainId: number]: Token[] } = {}
export const TOKENS_BY_SYMBOL_MAP: {
  [chainId: number]: { [symbol: string]: Token }
} = {}
export const WRAPPED_TOKENS_MAP: { [chainId: number]: Token } = {}
export const NATIVE_TOKENS_MAP: { [chainId: number]: Token } = {}

const CHAIN_IDS = Object.keys(TOKENS)

for (let j = 0; j < CHAIN_IDS.length; j++) {
  const chainId = Number(CHAIN_IDS[j])

  TOKENS_MAP[chainId] = {}
  TOKENS_BY_SYMBOL_MAP[chainId] = {}
  V1_TOKENS[chainId] = []
  V2_TOKENS[chainId] = []

  let tokens = TOKENS[chainId]
  let wrappedTokenAddress: string | undefined

  for (let i = 0; i < tokens.length; i++) {
    const token = tokens[i]
    TOKENS_MAP[chainId][token.address] = token
    TOKENS_BY_SYMBOL_MAP[chainId][token.symbol] = token

    if (token.isWrapped) {
      WRAPPED_TOKENS_MAP[chainId] = token
      wrappedTokenAddress = token.address
    }

    if (token.isNative) {
      NATIVE_TOKENS_MAP[chainId] = token
    }

    if (token.isV1Available && !token.isTempHidden) {
      V1_TOKENS[chainId].push(token)
    }

    if (!token.isPlatformToken && !token.isTempHidden) {
      V2_TOKENS[chainId].push(token)
    }
  }
  if (NATIVE_TOKENS_MAP[chainId] && NATIVE_TOKENS_MAP[chainId].wrappedAddress) {
    NATIVE_TOKENS_MAP[chainId].wrappedAddress = wrappedTokenAddress
  }
}

export function getWrappedToken(chainId: number) {
  return WRAPPED_TOKENS_MAP[chainId]
}

export function getNativeToken(chainId: number) {
  return NATIVE_TOKENS_MAP[chainId]
}

export function getTokens(chainId: number) {
  return TOKENS[chainId]
}

export function getV1Tokens(chainId: number) {
  return V1_TOKENS[chainId]
}

export function getV2Tokens(chainId: number) {
  return V2_TOKENS[chainId]
}

export function getTokensMap(chainId: number) {
  return TOKENS_MAP[chainId]
}

export function getWhitelistedV1Tokens(chainId: number) {
  return getV1Tokens(chainId)
}

export function getVisibleV1Tokens(chainId: number) {
  return getV1Tokens(chainId).filter((token) => !token.isWrapped)
}

export function isValidToken(chainId: number, address: string) {
  if (!TOKENS_MAP[chainId]) {
    // eslint-disable-next-line no-console
    IS_VERBOSE && console.log(`Incorrect chainId ${chainId}`)
    chainId = DEFAULT_CHAIN_ID
    // throw new Error(`Incorrect chainId ${chainId}`)
  }
  return address in TOKENS_MAP[chainId]
}

function getToken(chainId: number, address: string, shouldThrow?: true): Token
function getToken(
  chainId: number,
  address: string,
  shouldThrow?: false,
): Token | undefined
function getToken(
  chainId: number,
  address: string,
  shouldThrow: boolean = true,
): Token | undefined {
  if (!TOKENS_MAP[chainId]) {
    const msg = `Incorrect chainId ${chainId}`
    if (shouldThrow) {
      throw new Error(msg)
    } else {
      // eslint-disable-next-line no-console
      IS_VERBOSE && console.log(msg)
    }
  }
  if (!TOKENS_MAP[chainId][address]) {
    const msg = `Incorrect address "${address}" for chainId ${chainId}`
    if (shouldThrow) {
      throw new Error(msg)
    } else {
      // eslint-disable-next-line no-console
      IS_VERBOSE && console.log(msg)
    }
  }

  return TOKENS_MAP[chainId][address]
}
export { getToken }

export function getTokenBySymbol(chainId: number, symbol: string) {
  const token = TOKENS_BY_SYMBOL_MAP[chainId][symbol]
  if (!token) {
    throw new Error(`Incorrect symbol "${symbol}" for chainId ${chainId}`)
  }
  return token
}

export function convertTokenAddress(
  chainId: number,
  address: string,
  convertTo?: 'wrapped' | 'native',
) {
  const wrappedToken = getWrappedToken(chainId)

  if (convertTo === 'wrapped' && address === NATIVE_TOKEN_ADDRESS) {
    return wrappedToken.address
  }

  if (convertTo === 'native' && address === wrappedToken.address) {
    return NATIVE_TOKEN_ADDRESS
  }

  return address
}

export function getNormalizedTokenSymbol(tokenSymbol: string): string {
  if (['WBTC', 'wETH', 'WAVAX'].includes(tokenSymbol)) {
    return tokenSymbol.substr(1)
  } else if (tokenSymbol === 'BTC.b') {
    return 'BTC'
  }
  return tokenSymbol.toUpperCase()
}

export function isChartAvailabeForToken(chainId: number, tokenSymbol: string) {
  let token

  try {
    token = getTokenBySymbol(chainId, tokenSymbol)
  } catch (e) {
    return false
  }

  if (token.isChartDisabled || token.isPlatformToken) {
    return false
  }

  return true
}

export function getPriceDecimals(chainId: number, tokenSymbol?: string) {
  if (!tokenSymbol) {
    return 2
  }

  try {
    const token = getTokenBySymbol(chainId, tokenSymbol)
    return token.priceDecimals ?? 2
  } catch (e) {
    return 2
  }
}
